export const suppressionModalStyles = {
  dialogPaper: {
    borderRadius: "16px",
    maxHeight: "85vh",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  },
  dialogTitle: {
    padding: "24px 24px 20px 24px",
    borderBottom: "none",
    pb: 0,
  },
  title: {
    fontWeight: 600,
    fontSize: "20px",
    color: "#111827",
    letterSpacing: "-0.01em",
  },
  dialogContent: {
    padding: "0 24px 24px 24px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  tableContainer: {
    maxHeight: "55vh",
    overflowY: "auto",
    borderRadius: "12px",
    border: "1px solid #f0f0f0",
    backgroundColor: "#ffffff",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#d1d5db",
      borderRadius: "3px",
      "&:hover": {
        background: "#9ca3af",
      },
    },
  },
  table: {
    "& .MuiTableCell-root": {
      borderBottom: "1px solid #f5f5f5",
    },
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#fafafa",
    },
    "&:last-child td": {
      borderBottom: "none",
    },
  },
  headerCell: {
    backgroundColor: "#fafafa",
    fontWeight: 600,
    fontSize: "12px",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    padding: "16px 20px",
    position: "sticky",
    top: 0,
    zIndex: 10,
    borderBottom: "1px solid #f0f0f0",
    "&:first-of-type": {
      paddingLeft: "24px",
    },
    "&:last-of-type": {
      paddingRight: "24px",
    },
  },
  emailHeaderCell: {
    width: "30%",
    minWidth: "200px",
  },
  reasonHeaderCell: {
    width: "70%",
  },
  bodyCell: {
    padding: "16px 20px",
    "&:first-of-type": {
      paddingLeft: "24px",
    },
    "&:last-of-type": {
      paddingRight: "24px",
    },
  },
  emailBodyCell: {
    width: "30%",
    minWidth: "200px",
  },
  reasonBodyCell: {
    width: "70%",
  },
  emailText: {
    fontSize: "14px",
    color: "#111827",
    fontWeight: 500,
    fontFamily: "monospace",
    letterSpacing: "0.01em",
  },
  reasonText: {
    fontSize: "14px",
    color: "#111827",
    fontWeight: 400,
    lineHeight: "1.5",
    wordWrap: "break-word",
  },
  loaderBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "300px",
  },
  emptyStateBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "300px",
    padding: "3rem 2rem",
  },
  emptyStateText: {
    fontSize: "15px",
    color: "#9ca3af",
    textAlign: "center",
    fontWeight: 400,
  },
  dialogActions: {
    padding: "20px 24px 24px 24px",
    borderTop: "1px solid #f0f0f0",
    gap: "12px",
  },
  closeButton: {
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
    padding: "10px 24px",
    borderRadius: "8px",
    backgroundColor: "#367598",
    color: "#ffffff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#2d5f7a",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
  },
};
